import React from 'react'
import {useNavigate} from 'react-router-dom'

export default function ErrorsPage() {
  const navigation = useNavigate()
  return (
    <>
      <div className='d-flex align-items-center justify-content-center vh-100 footer'>
        <div className='text-center'>
          <h1 className='display-1 fw-bold text-white'>404</h1>
          <p className='fs-3 lead text-white fonts-600'>
            {' '}
            <span className='text-danger'>Opps!</span> Page not found.
          </p>
          <p className='lead text-white'>The page you’re looking for doesn’t exist.</p>
          <button
            className='mt-20 font-500 text-20 px-20 text-black'
            onClick={() => navigation('/')}
          >
            Go Home
          </button>
        </div>
      </div>
    </>
  )
}
